export class TimeSlot {
  constructor(public readonly from: Date, public readonly to: Date) {}
}
